const billingOptionMapping = {
    'account_lookup'    : 'My Account',
    'claim_lookup'      : 'Claim',
    'future_lookup'     : 'Future Claim'
};
Object.freeze(billingOptionMapping);
export default billingOptionMapping;
